<div class="location-browse-input">
  <div class="location-label mb-2">{{ label }}</div>
  <div
    class="flex items-center gap-2 border border-gray-300 rounded px-3 py-2 bg-white"
  >
    <span 
      class="flex-1 text-sm text-gray-700 truncate" 
      [pTooltip]="displayPath"
      tooltipPosition="top"
    >{{ displayPath }}</span>
    <button
      type="button"
      class="p-1 hover:bg-gray-100 rounded cursor-pointer"
      (click)="handleBrowseClick()"
      [pTooltip]="tooltip"
      [tooltipPosition]="tooltipPosition"
    >
      <img [src]="iconSrc" class="w-5 h-5" [alt]="iconAlt" />
    </button>
  </div>
</div>
